/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:49
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-camino-es",
	templateUrl: "camino-es.page.html",
	styleUrls: ["camino-es.page.scss"],
})

export class CaminoEsPage {

	// search query
	filterQuery: string = "";

	
	pageName:string = `camino-es` ;
	
	/**
	* CaminoEsPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public popoverController: PopoverController,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleBlackOpaque();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#0955b3");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	

		console.log(`CaminoEsPage`,`pageName`,this.pageName);
	}
	
	/**
	* CaminoEsPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	/**
	* CaminoEsPage:filterItems($event)
	* @param any $event
	*
	* @required for searchbar
	**/
	public filterItems(evt: any) {
		let filterVal = evt.target.value;
		if (filterVal && filterVal.trim() !== ""){
			// your code here
			this.filterQuery = filterVal.toLowerCase();
		}
		return true;
	}
	



	/**
	* CaminoEsPage:ngOnInit()
	* @param string $url = 'http://ihsana.com/'
	**/
	public ngOnInit()
	{
	}  


}
